// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"911d4157","455":"ad1acc5f"}[chunkId] + ".chunk.js";
};